import { jsx as _jsx } from "react/jsx-runtime";
export const SvgFilter = (props) => (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', xmlSpace: 'preserve', viewBox: '0 0 24 24', ...props, children: _jsx("path", { d: 'M4 4h16l-6 8v6l-4 3v-9z' }) }));
//# sourceMappingURL=filter.js.map